import React from "react";
import { Link } from "react-router-dom";
import { ExposedAPI } from "../../../apis/ExposedAPI";
import { slugify } from "../../../utils/utils";

export default function RelatedArticleCard({ article }) {
  const articleUrl = `/${slugify(article.cat_label)}/${slugify(
    article.sc_label
  )}/${slugify(article.usc_label)}/${article.slug}`;

  return (
    <div className={"related-article-card"}>
      <Link
        to={articleUrl}
        aria-label={`Voir la fiche produit ${article.label}`}
        style={{ position: "absolute", inset: 0, zIndex: 1 }}
      >
        <span className={"related-article-card-link-label"}>
          {article.label}
        </span>
      </Link>
      <img
        className={"related-article-card-image"}
        src={ExposedAPI.getThumbnailURL(article.id)}
        alt={article.label}
        width="160"
        height="140"
        loading="lazy"
      />
      <p className={"related-article-card-label"}>{article.label}</p>
      <p className={"related-article-card-price"}>{article.basePrice}€</p>
    </div>
  );
}
